<app-lms-modal-frame [title]="'Loan Agreement Checklist'" [pageHeadWidth]="900">
  <div modal-body>
    <p class="text-muted text-center my-3">Please confirm all items below before proceeding.</p>
    <div class="d-flex flex-column my-2 ps-2 gap-2">
      <div *ngFor="let item of checklistItems; let i = index" class="form-check d-flex align-items-start gap-2 py-1">
        <input class="form-check-input flex-shrink-0" type="checkbox" [id]="'checklist-item-' + i"
          [(ngModel)]="item.checked">
        <label class="form-check-label" [for]="'checklist-item-' + i">
          {{ item.label }}
        </label>
      </div>
    </div>

    <div class="row justify-content-center mt-2 g-2">
      <div class="col-4 text-center">
        <label for="reasonFirstLoan" class="form-label">Reason for 1st loan</label>
        <textarea id="reasonFirstLoan" class="form-control w-75" mdbInput role="text" aria-multiline="true" aria-rowspan="3" placeholder="Enter reason for 1st loan"
          [(ngModel)]="reasonForFirstLoan"></textarea>
      </div>
      <div class="col-4 text-center">
        <label for="reasonSecondLoan" class="form-label">Reason for 2nd loan</label>
        <textarea mdbInput role="text" aria-multiline="true" aria-rowspan="3"  id="reasonSecondLoan" class="form-control w-75"  rows="3" placeholder="Enter reason for 2nd loan"
          [(ngModel)]="reasonForSecondLoan"></textarea>
      </div>
    </div>
  </div>

  <div modal-actions class="lms-action-bar">
    <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button class="btn btn-primary" [disabled]="!allChecked" (click)="confirm()">
      <i class="fas fa-fw fa-check me-1"></i> Confirm
    </button>
  </div>
</app-lms-modal-frame>
